import {
  PlaneBufferGeometry,
  MeshBasicMaterial,
  Mesh,
  Color,
  Matrix4,
} from "three";

const cache = {};

class Plane {

  constructor( name, width = 64, height = 64, color = 0xff0000, vertical = true ) {

    /* SETUP */
    color = new Color(color);
    color.convertSRGBToLinear();

    if( !cache[width+'x'+height] ) cache[width+'x'+height] = {} // so we can cache similar size geos
    if( !cache[name] ) cache[name] = {} // so we can cache similar bitmap materials
    const useBitmap = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.bitmap :  false;
    const useWireframe = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.wireframe :  false;

    /* GEO */
    let geometry = cache[width+'x'+height].geometry || new PlaneBufferGeometry( width, height );
    if(!vertical) geometry.applyMatrix4( new Matrix4().makeRotationX(-Math.PI / 2) );
    if( !cache[width+'x'+height].geometry ) cache[width+'x'+height].geometry = geometry;

    /* MATERIAL */
    let material;
    if( !cache[name].material && window.ASSETS && useBitmap ){
      material = window.ASSETS.textures.find(obj => { return obj.name === name }).material
      cache[name].material = material
    }else if( !cache[name].material ){
      material = new MeshBasicMaterial();
      material.needsUpdate = false;
      cache[name].material = material
    }else{
      material = cache[name].material;
    }

    if( !useBitmap ) material.color.set( color );
    if( useWireframe ) material.wireframe = useWireframe;

    /* MESH */
    const mesh = new Mesh( geometry, material );
    mesh.matrixAutoUpdate = false; // if static
    return mesh;
  }
}

export { Plane };